<template>
  <div class="page-content">
    <Hero/>
    <HowItWorks/>
    <Arguments/>
    <Why/>
    <Reviews/>
  </div>
</template>

<script setup>
import {getPageDetails, getContactDetails} from '@/service/pageInfo'
import Hero from '@/components/Hero.vue';
import HowItWorks from '@/components/HowItWorks.vue';
import Arguments from '@/components/Arguments.vue';
import Why from '@/components/Why.vue';
import Reviews from '@/components/Reviews.vue';
import {useStore} from 'vuex';

const store = useStore()

const getPartnerName = () => {
  if(Boolean(Number(process.env.VUE_APP_IS_DEV))) {
    const name = new URLSearchParams(window.location.search).get('partner');
    if(name) {
      return name;
    } else {
      return undefined;
    }
  } else {
    const host = window.location.hostname
    const parts = host.split('.');
    
    if (parts.length > 2) {
      return parts.slice(0, -2).join('.'); // Return everything before domain and TLD
    } else {
      return undefined;
    }
  }
}

const partner = getPartnerName()
if(partner){
  getPageDetails(partner)
      .then(response => {
        store.commit('updatePageContent', response.data)
      })
      .catch(error => console.log(error))
}

getContactDetails()
    .then(response => {
      store.commit('updateContactDetails', response.data)
    })
    .catch(error => console.log(error))

defineProps({
  pageData: Object
})
</script>

<style lang="scss" scoped>
.page-content {
  padding-top: 70px;
}
</style>
